module.exports = __webpack_public_path__ + "static/media/downArrow.e152ba30.svg";